
namespace Matrix.Rebalancer {

    @Serenity.Decorators.registerEditor("Matrix.Rebalancer.SummaryViewFormatGrid", [Serenity.IReadOnly])
    @Serenity.Decorators.element("<div/>")
    export class SummaryViewFormatGrid extends SiteEntityGrid<SummaryViewFormatRow, any>
        implements Serenity.IReadOnly {
        protected getColumnsKey() { return 'Rebalancer.SummaryViewFormat'; }
        protected getDialogType() { return SummaryViewFormatDialog; }
        protected getIdProperty() { return SummaryViewFormatRow.idProperty; }
        protected getLocalTextPrefix() { return SummaryViewFormatRow.localTextPrefix; }
        protected getService() { return SummaryViewFormatService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        protected getInitialTitle() {
            return null;
        }

        private _viewCode: string;

        public set viewCode(value: string) {
            if (this._viewCode !== value) {
                this._viewCode = value;
                this.setEquality(SummaryViewFormatRow.Fields.ViewCode, value);
                this.refresh();
            }
        }

        protected addButtonClick() {
            this.editItem(<SummaryViewFormatRow>{
                ViewCode: this._viewCode
            });
        }

        protected getGridCanLoad() {
            return super.getGridCanLoad() && !!this._viewCode;
        }

        protected updateInterface() {
            this.toolbar.findButton('add-button').toggle(!this._readOnly && !!this._viewCode);
        }

        private _readOnly: boolean;

        get_readOnly(): boolean {
            return !!this._readOnly;
        }

        set_readOnly(value: boolean): void {
            if (!!this._readOnly !== !!value) {
                this._readOnly = !!value;
                this.updateInterface();
            }
        }
    }
}